import Chart from "chart.js/auto"

// Renders barWithErrorBars charts from <canvas class="error-bar-chart"> elements.
// Registration of BarWithErrorBarsController happens in application.js.
//
// Data format (in data-chart attribute as JSON):
//   [
//     { label: "Branch", color: "#0275D8", data: [{ y: 120, yMin: 100, yMax: 140 }, ...] },
//     { label: "Master", color: "#5CB85C", data: [{ y: 115, yMin: 105, yMax: 125 }, ...] }
//   ]
//
// Additional data attributes:
//   data-labels: JSON array of x-axis category labels
//   data-ytitle: y-axis title
//   data-max: optional max y value

function renderErrorBarCharts() {
  document.querySelectorAll("canvas.error-bar-chart").forEach((canvas) => {
    if (canvas.dataset.rendered) return
    canvas.dataset.rendered = "true"

    const series = JSON.parse(canvas.dataset.chart)
    const labels = JSON.parse(canvas.dataset.labels)
    const significances = canvas.dataset.significances
      ? JSON.parse(canvas.dataset.significances)
      : []
    const ytitle = canvas.dataset.ytitle || ""
    const max = canvas.dataset.max ? parseFloat(canvas.dataset.max) : undefined

    const css = getComputedStyle(document.documentElement)
    const v = (name) => css.getPropertyValue(name).trim()

    const SIGNIFICANCE_COLORS = {
      regression_strong: { border: v("--ci-regression-strong"), borderWidth: 3 },
      regression: { border: v("--ci-regression"), borderWidth: 2 },
      improvement_strong: { border: v("--ci-improvement-strong"), borderWidth: 3 },
      improvement: { border: v("--ci-improvement"), borderWidth: 2 },
      added: { border: v("--ci-neutral"), borderWidth: 2 },
      removed: { border: v("--ci-neutral"), borderWidth: 2 },
    }

    const datasets = series.map((s) => {
      // Per-bar border colors based on significance (only for branch series)
      const borderColors = s.data.map((d) => {
        const sig = d.significance
        return sig && SIGNIFICANCE_COLORS[sig]
          ? SIGNIFICANCE_COLORS[sig].border
          : s.color
      })
      const borderWidths = s.data.map((d) => {
        const sig = d.significance
        return sig && SIGNIFICANCE_COLORS[sig]
          ? SIGNIFICANCE_COLORS[sig].borderWidth
          : 1
      })

      return {
        label: s.label,
        backgroundColor: s.color,
        borderColor: borderColors,
        borderWidth: borderWidths,
        data: s.data,
        // Inner (p95) bars are thicker, outer (p99) thinner
        errorBarLineWidth: { v: [2, 1] },
        errorBarWhiskerLineWidth: { v: [2, 1] },
        errorBarWhiskerRatio: { v: [0.4, 0.25] },
        errorBarColor: { v: ["#333", "#999"] },
        errorBarWhiskerColor: { v: ["#333", "#999"] },
      }
    })

    new Chart(canvas, {
      type: "barWithErrorBars",
      data: { labels, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: datasets.length > 1 },
        },
        scales: {
          x: {
            ticks: {
              autoSkip: false,
              maxRotation: 90,
              color: (ctx) => {
                const sig = significances[ctx.index]
                return SIGNIFICANCE_COLORS[sig]
                  ? SIGNIFICANCE_COLORS[sig].border
                  : "#666"
              },
            },
          },
          y: {
            beginAtZero: true,
            max: max,
            title: { display: !!ytitle, text: ytitle },
          },
        },
      },
    })
  })
}

document.addEventListener("turbolinks:load", renderErrorBarCharts)
document.addEventListener("DOMContentLoaded", renderErrorBarCharts)
